export default __webpack_public_path__ + "img/40ace0a5fb1de018d51035cf48228cda.mp4";